(function () {
    "use strict";

    angular.module("app").controller("SearchCisController", SearchCisController);
    SearchCisController.$inject = ["controllerDecorator", "infiniteScrollDataSourceFactory", "cisDossier", "habilDate"];
    function SearchCisController(controllerDecorator, infiniteScrollDataSourceFactory, cisDossier, habilDate) {
        const vm = this;
        controllerDecorator.Decorate(vm, ["navigation", "files", "dialog"]);

        Object.defineProperty(vm, "Filter", { get: () => vm.DataSource.GetFilter() });
        Object.defineProperty(vm, "PageAndSort", { get: () => vm.DataSource.GetPageAndSort() });
        Object.defineProperty(vm, "Items", { get: () => vm.DataSource.Items() });

        vm.GetStyle = getStyle;
        vm.DownloadExport = downloadExport;
        
        initialize();

        function initialize() {
            vm.DataSource = infiniteScrollDataSourceFactory.Create(cisDossier.Search, (v) => vm.isLoadingRequests = v);

            if (vm.PageAndSort.SortBy.length > 0) {
                vm.sortType = vm.PageAndSort.SortBy[0].Name;
                vm.sortReverse = vm.PageAndSort.SortBy[0].IsReverse;
            }
            else {
                vm.sortType = "Cis.Identifier";
                vm.sortReverse = false;
            }

            vm.SetLoadingState(false);
        }

        function getStyle(dossier) {
            //if (dossier.Organisation.ClearanceExpiration === null || dossier.Organisation.HasExpiredClearance)
            //    return "overview-expired";

            if (!dossier.ApprovedUntil)
                return "";

            const expiration = habilDate.GetDateOnly(dossier.ApprovedUntil);
            const today = habilDate.GetDateOnly(new Date());

            if (expiration.valueOf() < today.valueOf())
                return "overview-expired";

            const oneYearFromNow = habilDate.GetDateOnly(new Date()).setFullYear(today.getFullYear() + 1);
            if (expiration.valueOf() < oneYearFromNow.valueOf())
                return "overview-expiring";

            return "overview-valid";
        }

        function downloadExport() {
            vm.SetLoadingState(true);

            const filter = vm.DataSource.GetFilter();
            cisDossier.DownloadExport(
                { Filter: filter },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }
    }
})();
